export default "__VITE_ASSET__Cidy8wdv__"